import {
  openInlineRovoPrompt,
  InlineRovoPromptTriggerSource,
} from '@databases/database-ai-first-creation-state/inline-rovo-prompt-state';
import { AskRovoIcon } from '@databases/database-ai-first-creation-ui/icons/ask-rovo-icon';
import { messages } from '@databases/intl/messages';
import React, { useEffect } from 'react';

import { getExperimentValue } from '@canvas/client-feature-flags';

import { SELECT_VALUE_MENU_ACTIONS } from '../../../select-value-menu/types';
import { ElementBeforeIconWrapper } from '../../../select-value-menu/ui/components';
import { type SelectionsEffectMenuItemBuilder } from '../types';

const RovoElemBefore = () => {
  useEffect(() => {
    getExperimentValue('databasesAIFC', 'enabled', {
      fireExperimentExposure: true,
    });
  }, []);

  return (
    <ElementBeforeIconWrapper>
      <AskRovoIcon height={16} width={16} />
    </ElementBeforeIconWrapper>
  );
};

export const askRovoMenuItem: SelectionsEffectMenuItemBuilder = (
  context,
  actions,
  skip
) => {
  if (!context.capabilities.canAskRovo) {
    return skip;
  }

  return () => ({
    key: SELECT_VALUE_MENU_ACTIONS.ASK_ROVO,
    content: context.formatMessage(messages['value-actions.ask-rovo']),
    onClick: () => {
      openInlineRovoPrompt(InlineRovoPromptTriggerSource.TableEntry);

      context.closeMenu();
    },
    elemBefore: <RovoElemBefore />,
  });
};
